import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseDatePicker } from 'app/components/common/pickers/BaseDatePicker'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { Dates, FONT_SIZE, FONT_WEIGHT, FORMAT_ONLY_MONTH } from 'parkway-web-common'
import React from 'react'
import styled from 'styled-components'
import { IFilterMonthlyRosterReport } from '../../type'

interface IProps {
  onChange?: (value: IFilterMonthlyRosterReport) => void
  formData?: IFilterMonthlyRosterReport
}

export const FilterLayout: React.FC<IProps> = ({ formData, onChange }) => {
  const onChangeYear = (value: string) => {
    onChange && onChange({ ...formData, year: value })
  }

  const onChangeMonth = (value: string) => {
    onChange && onChange({ ...formData, month: value })
  }
  return (
    <BaseForm>
      <RootWrapper gutter={[16, 8]} align={'middle'}>
        <BaseCol xl={8}>
          <BaseFormItem hiddenLabel>
            <Picker
              $prefix="Year"
              picker="year"
              value={
                formData?.year ? Dates.getDate(`${formData?.year}-01-01`) : null
              }
              onChange={(_, value) => onChangeYear(value)}
              allowClear={false}
            />
          </BaseFormItem>
        </BaseCol>
        <BaseCol xl={8}>
          <BaseFormItem hiddenLabel>
            <Picker
              $prefix="Month"
              picker="month"
              value={
                formData?.year
                  ? Dates.getDate(`${formData?.year}-${formData?.month}-01`)
                  : null
              }
              onChange={(_, value) => onChangeMonth(value)}
              allowClear={false}
              $prefixWidth={70}
              format={FORMAT_ONLY_MONTH}
            />
          </BaseFormItem>
        </BaseCol>
      </RootWrapper>
    </BaseForm>
  )
}

const RootWrapper = styled(BaseRow)`
  padding: 8px;
`
const Picker = styled(BaseDatePicker)<{
  $prefix: string
  $prefixWidth?: number
}>`
  width: 100%;
  border: 1px solid ${convertedVariables.neutralBlack9Color};
  &:hover {
    border: 1px solid ${convertedVariables.neutralBlack9Color};
  }
  .ant-picker-input::before {
    content: '${props => props?.$prefix ?? '-'}:';
    font-size: ${FONT_SIZE.xs};
    font-weight: ${FONT_WEIGHT.medium};
    color: ${convertedVariables.primaryColor};
    opacity: 0.4;
    width: ${props => props?.$prefixWidth ?? 50}px;
  }
`

const BaseFormItem = styled(BaseForm.Item)`
  margin-bottom: 0px !important;
`
